'use client'

import color from '@ui/style/color.theme'

interface Icon32TextSizeProps {
	isDark?: boolean
}
export const Icon32TextSize = ({ isDark }: Icon32TextSizeProps) => {
	const colorValue = isDark ? color.colWhite : color.colBlack
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
		>
			<path
				d="M25.6269 8V12.8703H28V14.4169H25.6269V23H23.6612V8H25.6269ZM13 18.8925C16.8961 17.0632 19.0035 14.5188 19.3932 11.0931H13.8678V9.56319H21.3943C21.3855 13.9784 19.4374 17.8614 14.1157 20.3226L13 18.8925Z"
				fill={colorValue}
			/>
			<path
				d="M10.8344 14.8008V14.7008H10.7344H9.68595H9.58595V14.8008V22.8008V22.9008H9.68595H10.7344H10.8344V22.8008V18.4008H12H12.1V18.3008V17.4759V17.3759H12H10.8344V14.8008ZM3.9575 20.5196L3.84409 20.5728L3.92115 20.6716L4.5162 21.4344L4.565 21.4969L4.63702 21.4636C6.07051 20.8006 7.05607 19.943 7.68319 18.9478C8.31022 17.9527 8.57459 16.827 8.57698 15.6347L8.57718 15.5345H8.47698H4.46281H4.36281V15.6345V16.4504V16.5504H4.46281H7.29643C7.06133 18.2779 5.97056 19.5744 3.9575 20.5196Z"
				fill={colorValue}
				stroke={colorValue}
				strokeWidth="0.2"
			/>
		</svg>
	)
}
